'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (FAQMobileContact, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.FAQMobileContact = $('[data-faq-mobile-contact]');
      $dom.FAQContent = $('[data-faq-content]');
    };

    var FAQMobileContactInit = function FAQMobileContactInit() {
      var stickyFAQContact = function stickyFAQContact() {
        if ($dom.FAQMobileContact.length > 0 && $(window).width() < 992) {
          var contentHeight = $dom.FAQContent.outerHeight();
          var contentOffset = $dom.FAQContent.offset().top - $(window).height();
          var contentBottom = contentOffset + contentHeight;
          if ($(window).scrollTop() > contentBottom) {
            if ($dom.FAQMobileContact.is(':visible')) {
              $dom.FAQMobileContact.fadeOut(300);
            }
          } else {
            if (!$dom.FAQMobileContact.is(':visible')) {
              $dom.FAQMobileContact.fadeIn(300);
            }
          }
        }
      };

      stickyFAQContact();
      $(window).on('scroll', function () {
        stickyFAQContact();
      });
    };

    FAQMobileContact.init = function () {
      cacheDom();
      FAQMobileContactInit();
    };
  })(window.FAQMobileContact = window.FAQMobileContact || {}, _jquery2.default, undefined);
};